module.exports = __webpack_public_path__ + "img/mvp.0af55bc7.png";